import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag2Sparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bag 2-sparkle, shopping, add, plus"><path d="M11.75 21.25H4.25L6.25 7.75H17.75L18.4537 12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15.25 7.75V6C15.25 4.20507 13.7949 2.75 12 2.75C10.2051 2.75 8.75 4.20507 8.75 6V7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M18.4 15H17.6L16.6 17.6L14 18.6V19.4L16.6 20.4L17.6 23H18.4L19.4 20.4L22 19.4V18.6L19.4 17.6L18.4 15Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBag2Sparkle;
